import equalHeights from 'global/equalHeights';
import Ajax from 'global/od/Ajax';

const { events } = window.od;
const { nodeIter } = window.od.util;

export default class ProductZone {
	constructor(zoneElement) {
		this.element = zoneElement;
		this.placmentId = this.element.getAttribute('data-related-product-zone');
		this.title = '';
		this.products = [];
		this.excludeProductsWithMinMaxQtyByItsPlacement = [
			'cart_page.Replenishment',
		];
	}

	addResults(zoneResult) {
		this.title = zoneResult.title;
		this.products = zoneResult.products;
	}

	requestRender(externalVisitor) {
		return this.requestTemplate().then(response => {
			this.render(response.data, externalVisitor);
			this.addTrackingUrls();
			return this;
		});
	}

	requestTemplate() {
		const skuList = Object.keys(this.products);
		const shouldProductsWithMinQtyBeExcluded =
			this.excludeProductsWithMinMaxQtyByItsPlacement.includes(this.placmentId);
		return Ajax({
			method: 'GET',
			url: '/ajax/product/list',
			data: {
				productIds: skuList.join(','),
				withoutMinQtyProducts: shouldProductsWithMinQtyBeExcluded,
			},
			Accept: 'text/html',
		});
	}

	constructZoneCategoryLink(content, url, className) {
		const titleLinkContent = document.createTextNode(content);
		const titleLinkElement = document.createElement('a');
		titleLinkElement.href = url;
		titleLinkElement.classList.add(className);
		titleLinkElement.appendChild(titleLinkContent);
		return titleLinkElement;
	}

	stringDecode(str) {
		const txt = document.createElement('textarea');
		txt.innerHTML = str;
		return txt.value;
	}

	render(renderedHtml, externalVisitor) {
		this.element.innerHTML = renderedHtml;
		const titleClass = '.cross-sell-zone__title-text';
		const titleElement = this.element.querySelector(titleClass);
		const zone = this.placmentId;
		const landingZoneForExternalUrl = 'item_page.h0_PPC';
		const landingZoneForInternalUrl = 'item_page.h0_nonPPC';

		if (titleElement) {
			titleElement.innerHTML = this.title;

			if (
				(externalVisitor && zone === landingZoneForExternalUrl) ||
				(!externalVisitor && zone === landingZoneForInternalUrl)
			) {
				const productConfig = window.RR_CONFIG.product.category;
				const catUrl = productConfig.url;
				const catName = productConfig.name;

				if (catName && catUrl) {
					const landingZoneElement = document.querySelector(
						`[data-related-product-zone="${
							externalVisitor
								? landingZoneForExternalUrl
								: landingZoneForInternalUrl
						}"]`,
					);
					const reg = /\[{2}.*?\]{2}/g;
					const catLinkTxt = productConfig.linkText;
					const catNamePlaceholder = catLinkTxt.match(reg)[0];
					const catLinkEncoded = catLinkTxt.replace(
						catNamePlaceholder,
						catName,
					);
					const catLinkDecoded = this.stringDecode(catLinkEncoded);
					const catLinkClass = 'cross-sell-zone__title-link';
					const catLink = this.constructZoneCategoryLink(
						catLinkDecoded,
						catUrl,
						catLinkClass,
					);
					const landingZoneTitle = landingZoneElement.querySelector(titleClass);

					landingZoneTitle.after(catLink);
				}

				this.toggleCrossSellZoneWrapper();
				this.listenForCloseCrossSellZone();
			}
		}

		equalHeights(this.element);

		events.publish('richRelevance_Loaded', {
			placmentId: this.placmentId,
			productIds: this.products,
			element: this.element,
		});

		$('[data-toggle="tooltip"]').tooltip();
	}

	toggleCrossSellZoneWrapper() {
		const crossSellZoneWrapper = document.querySelector(
			'.product-cross-sell-zone-on-landing',
		);

		crossSellZoneWrapper?.classList.toggle('hidden');
	}

	listenForCloseCrossSellZone() {
		const closeButton = document.querySelector(
			'.product-cross-sell-zone-on-landing__close-button',
		);

		closeButton?.addEventListener('click', this.toggleCrossSellZoneWrapper);
	}

	addTrackingUrls() {
		const productElements = this.element.querySelectorAll('[data-legacy-sku]');
		nodeIter(productElements, elmt => {
			const legacySku = elmt.getAttribute('data-legacy-sku');
			const rrLink = this.products[legacySku];
			ProductZone.addThirdPartyTrackingData(elmt, rrLink);
			nodeIter(elmt.querySelectorAll('[href]'), link => {
				link.setAttribute('href', rrLink);
			});
		});
	}

	// TODO this is altering the AddToCart form and should be in AddToCart.js
	// It's here to stop circular dependencies.
	static addThirdPartyTrackingData(formContainer, trackingUrl) {
		// This stops RR returning a 301 which was causing a second tracking request to be sent.
		const thirdPartyUrl = trackingUrl?.replace(/&ct=.*$/, '');

		formContainer.querySelector('form').setAttribute(
			'data-tracking-meta',
			JSON.stringify({
				onAddToCartUrl: thirdPartyUrl,
			}),
		);
	}

	hasProducts() {
		return !!this.element.querySelectorAll('.cross-sell-zone__product').length;
	}
}
